<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-tabs card @input="activateTab">
        <template #tabs-start>
          <li role="presentation" class="nav-item align-self-center mr-2">
            <b-button :to="prevRoute?prevRoute:{ name: 'EmployeesNew' }">
              {{ $dt('global.back', 'Back') }}
            </b-button>
          </li>
          <li role="presentation" class="nav-item align-self-center mr-2">
            <b-spinner v-if="spinners.loading" type="grow" variant="primary" />
            <template v-else-if="!employee.id">
              <i class="mx-1 fa fa-exclamation-triangle fa-lg text-danger" />
            </template>
            <template v-else>
              <div class="text-center">
                <div>{{employee.displayName}}</div>
                <div v-if="employee.email"><small>{{employee.email}}</small></div>
              </div>
              <!-- <strong>[{{project.key}}]</strong> -->
            </template>
          </li>
          <b-nav-item v-for="(t, idx) in tabs" :key="`p-home-t-${t.key}`" :active="cat===t.key"
            @click="activateTab(t.key)" :disabled="spinners.loading || !hasAllActions(t.actions)">
            {{t.title}}
          </b-nav-item>
          <b-nav-item v-if="employee.external_id" :href="`https://applyit.atlassian.net/people/${employee.external_id}`">
            <img class="tab-logo" src="@/assets/jira_logo.png" /> {{$dt('employee-home.goto-jira', 'Jira')}}
          </b-nav-item>
        </template>
        <div :class="['p-2',...[activeTab.bodyClass]]">
          <b-spinner v-if="spinners.loading" type="grow" variant="primary" />
          <b-alert v-else-if="!employee.id" class="mb-0" variant="danger" show>
            {{$dt('employee-home.employee-not-found-info','Employee not found!')}}
          </b-alert>
          <EmployeeForm v-else-if="canSeeAndIsActiveTab('employee_form')" :id="employee.id" />
          <EmployeeRates v-else-if="canSeeAndIsActiveTab('employee_rates')" :id="employee.id" />
        </div>
      </b-tabs>
      <!-- {{prevRoute}} -->
    </b-card>
  </div>
</template>

<script>
import Services from '@/services/index';
import EmployeeForm from '@/views/Employees/EmployeeForm';
import EmployeeRates from '@/views/Employees/EmployeeRates';

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name !== null) {
        // console.log('prevroute', vm, [to, from]);
        const { name, params, query } = from;
        vm.prevRoute = { name, params, query };
      }
    });
  },

  mounted() {
    this.load();
  },
  data() {
    return {
      prevRoute: null,
      spinners: {
        loading: false,
        isSaving: false,
      },
      employee: {},
      tabs: [
        { key: 'employee_form', actions: ['admin'], bodyClass: '', title: this.$dt('employee-home.employee_form', 'Employee Form') },
        { key: 'employee_rates', actions: ['admin'], bodyClass: '', title: this.$dt('employee-home.employee_rates', 'Rates') },
      ],
    };
  },
  props: {
    id_or_email: { type: [Number, String], required: true },
    cat: { type: String, default: 'employee_form' },
  },
  components: {
    EmployeeForm,
    EmployeeRates,
  },
  computed: {
    act() {
      return this.employee && this.employee.actions ? this.employee.actions : {};
    },
    activeTab() {
      return this.tabs.find((t) => t.key === this.cat);
    }
  },
  watch: {
    id_or_email() {
      this.load();
    }
  },
  methods: {
    canSeeAndIsActiveTab(cat) {
      return this.cat === cat && this.hasAllActions(this.tabs.find((t) => t.key === cat)?.actions || []);
    },
    hasAllActions(actions) {
      if (!actions) return true;
      const available = actions.filter((a) => this.act[a]);
      return actions.length === available.length;
    },
    load() {
      this.spinners.loading = true;
      this.employee = {};
      Services.jira.employeeInfo({ id_or_email: this.id_or_email }).then(({ data }) => {
        this.employee = data.employee;
        this.spinners.loading = false;
        if (!this.employee.actions.admin && this.cat !== 'employee_form') {
          this.$router.push({ name: 'EmployeeHome', params: { id_or_email: this.id_or_email, cat: 'employee_form' } });
        }
      }).catch(() => {
        this.spinners.loading = false;
      });
    },
    activateTab(cat) {
      if (this.cat !== cat) {
        this.$router.push({ name: 'EmployeeHome', params: { id_or_email: this.id_or_email, cat } });
      }
    }
  }
};
</script>

<style scoped>
.tab-logo {
  max-height: 1.8em;
  margin-bottom: -0.5em;
  margin-top: -0.5em;
}
</style>
